import React, { useCallback } from 'react';
import { Box, ButtonV2, TextV2 } from '@withjoy/joykit';
import { DrawerV2, DrawerV2Props } from '@withjoy/joykit/components/DrawerV2';
import { useTranslation } from '@shared/core';
import { withWindow } from '@shared/utils/withWindow';
import { useRefinementsPanelProvider } from '../RefinementsPanel/RefinementsPanel.provider';
import { RefinementFacetList, refinementFacetSkeletonId } from '../RefinementFacetList';
import { RefinementsPanelProps } from '../RefinementsPanel';
import { StyledClearFiltersContainer, styles } from './RefinementsPanelMobileDrawer.styles';

const DRAWER_OVERRIDES: DrawerV2Props['overrides'] = {
  Content: {
    props: {
      opacity: '1 !important',
    },
  },
};

export const RefinementsPanelMobileDrawer: React.FC<RefinementsPanelProps> = (props: RefinementsPanelProps) => {
  const { isOpen, closePanel, getTotalActiveFilterCount, clearAllSearchFilters } = useRefinementsPanelProvider();
  const totalFiltersCount = getTotalActiveFilterCount();
  const { t } = useTranslation('catalogRegistry');
  const tRefinementsPanel = t('refinementsPanel');

  const handleClearAllFilters = useCallback(() => {
    clearAllSearchFilters();
    withWindow(() => {
      const refinementFacetSkeleton = document.getElementById(refinementFacetSkeletonId);
      if (refinementFacetSkeleton) {
        refinementFacetSkeleton.scrollTop = 0;
      }
    });
  }, [clearAllSearchFilters]);
  return (
    <DrawerV2
      isOpen={isOpen}
      anchor="bottom"
      size={1}
      useBackdrop={false}
      onClose={closeProps => {
        if (closeProps.closeSource === 'closeButton') {
          closePanel(closeProps.event as React.MouseEvent<HTMLElement>);
        }
      }}
      overrides={DRAWER_OVERRIDES}
    >
      <DrawerV2.CloseButton
        data-togglemethod="close"
        color="black"
      />
      <DrawerV2.Body
        maxHeight="100%"
        paddingBottom={[0, 0, 0]}
        paddingTop={[60, 60, 60]}
      >
        <Box
          display="flex"
          flexDirection="column"
          flexGrow={1}
          justifyContent="flex-start"
          __css={styles.contentContainer}
        >
          <RefinementFacetList {...props} />
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            __css={styles.spacingStack}
          >
            <StyledClearFiltersContainer
              __css={styles.clearFiltersContainer}
              onClick={handleClearAllFilters}
              disabled={totalFiltersCount === 0}
            >
              <TextV2
                typographyVariant="hed2"
                textTransform="capitalize"
                as="span"
                paddingLeft={5}
              >
                {tRefinementsPanel.clearAll()}
              </TextV2>
            </StyledClearFiltersContainer>
            <ButtonV2
              variant="solid"
              intent="primary"
              overrides={styles.registryPrimaryButton}
              onClick={closePanel}
              flex="1"
            >
              {tRefinementsPanel.refineFilters()}
            </ButtonV2>
          </Box>
        </Box>
      </DrawerV2.Body>
    </DrawerV2>
  );
};

RefinementsPanelMobileDrawer.displayName = 'RefinementsPanelMobileDrawer';
